import { Outlet } from "react-router-dom";
import PageState from "../components/PageState";
import Header from "../components/header/Header";
import Notification from "../components/notification/Notification";

function QuickStartLayout() {
  return (
    <>
      <PageState />
      <main>
        <div className="w-100">
          <Header />
          <div id="content">
            <Outlet />
          </div>
        </div>
        <Notification />
      </main>
    </>
  );
}

export default QuickStartLayout;
